module.exports = __webpack_public_path__ + "img/Figure-10-2-min.e9b5980d.svg";